var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1677,
    height: 896,
    viewBox: "0 0 1677 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "#FF3D63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M737 302.383C737 282.514 758.383 269.987 775.714 279.703L994.024 402.089C1011.63 411.962 1011.76 437.265 994.254 447.317L775.945 572.643C758.611 582.594 737 570.081 737 550.094V302.383Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3be9c3753f19fed920fa5581ca671bfb.svg";
export { ForwardRef as ReactComponent };